import script from "./TaccuinoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaccuinoPage.vue?vue&type=script&setup=true&lang=ts"

import "./TaccuinoPage.vue?vue&type=style&index=0&id=5d9d4049&lang=css"

const __exports__ = script;

export default __exports__